
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { API_BASE_URL } from "../../../../utils/index";
// import Form from "react-bootstrap/Form";
// import DescriptionTypesField from "../../../../components/DescriptionNameType/DescriptionTypesField";
// import { useAuthHeaders } from "../../../../components/Token";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import CancelButton from "../../../../components/MinorComponents/CancelButton";
// import { GETSingleDESTYPe, UpdateDESVendorTYPe } from "../../../../services/api/DescriptionType";
// import { Button } from "@mui/material";


// function EditDescriptionNameVendorTypesDetialEdit() {
//   const { _id } = useParams();
//   const [newEditDescriptionNameType, setNewEditDescriptionNameType] = useState("");
//   const [conditionMethod, setConditionMethod] = useState("");
//   const [tags, setTags] = useState([]);
//   const [discriptionMethod, setDiscriptionMethod] = useState([]);
//   const navigate = useNavigate();
//   const subdomain = localStorage.getItem("vendorsubdomain");
//   const headers = useAuthHeaders();

//   const textValues = tags.map((item) => item.text);

//   useEffect(() => {
//     // axios
//     //   .get(`${API_BASE_URL}/admin/singledescriptiontype/${_id}`)
//     //   .then((response) => {
//     const fetchData = async () => {

//       const response = await GETSingleDESTYPe(subdomain, _id)
//       console.log(response, "response")
//       if (response.success) {

//         const data = response.descriptiontype;
//         console.log(data, "data>>>>")
//         setNewEditDescriptionNameType(data);
//         setConditionMethod(data?.type);
//         setTags(data?.descriptionnametypes?.map((tag) => ({ id: tag, text: tag })));
//       }
//     }
//     fetchData()
//     // })
//     // .catch((error) => {
//     //   console.error("Error fetching description type:", error);
//     // });

//     axios
//       .get(`${API_BASE_URL}/type/admin/gettypes`, { headers })
//       .then((response) => {
//         setDiscriptionMethod(response.data?.types || []);
//       })
//       .catch((error) => {
//         console.error("Error fetching types:", error);
//       });
//   }, [_id, headers]);

//   const handleSave = async (e) => {
//     e.preventDefault();

//     const payload = { descriptionnametypes: textValues };

//     try {
//       const response = await UpdateDESVendorTYPe(subdomain, payload, _id);

//       if (response?.success) {
//         Swal.fire({
//           icon: "success",
//           title: response.message,
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate(`/${subdomain}/master/description-type`);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Update failed",
//           text: response?.message || "Something went wrong",
//         });
//       }
//     } catch (err) {
//       console.error("Update error:", err);
//       Swal.fire({
//         icon: "error",
//         title: "Server Error",
//         text: "Unable to update the record.",
//       });
//     }
//   };

//   return (
//     <div className="p-3">
//       <h2>Edit Description Name Type</h2>
//       <form onSubmit={handleSave} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <div className="row category-field">
//           <div className="d-flex align-items-center my-2">
//             <h6 className="m-0">Category :</h6>
//             <p className="m-0 px-2">{newEditDescriptionNameType?.category?.name}</p>
//           </div>

//           <div className="d-flex align-items-center my-2">
//             <h6 className="m-0">Sub Category :</h6>
//             <p className="m-0 px-2">{newEditDescriptionNameType?.subcategory?.name}</p>
//           </div>

//           <div className="d-flex align-items-center my-2">
//             <h6 className="m-0">Description Name Type :</h6>
//             <p className="m-0 px-2">{newEditDescriptionNameType?.descriptionname?.descriptionName}</p>
//           </div>

//           <div className="d-flex align-items-center my-2">
//             <h6 className="m-0">Type :</h6>
//             <p className="m-0 px-2">{newEditDescriptionNameType?.type}</p>
//           </div>

//           {(conditionMethod === "Drop Down" || conditionMethod === "Check Box") && (
//             <div className="col-md-4 my-4">
//               <DescriptionTypesField setTags={setTags} tags={tags} />
//             </div>
//           )}
//         </div>
//         <div className="buttons">
//           <Button type="submit" style={{ backgroundColor: "#0443C0", color: "white" }}>
//             Save
//           </Button>
//           <CancelButton path="/viewDescriptionNameTypes" />
//         </div>
//       </form>
//     </div>
//   );
// }

// export default EditDescriptionNameVendorTypesDetialEdit;


import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
  Grid,
  Paper,
} from "@mui/material";
import { API_BASE_URL } from "../../../../utils/index";
import DescriptionTypesField from "../../../../components/DescriptionNameType/DescriptionTypesField";
import { useAuthHeaders } from "../../../../components/Token";
import CancelButton from "../../../../components/MinorComponents/CancelButton";
import {
  GETSingleDESTYPe,
  UpdateDESVendorTYPe,
} from "../../../../services/api/DescriptionType";

function EditDescriptionNameVendorTypesDetialEdit() {
  const { _id } = useParams();
  const [newEditDescriptionNameType, setNewEditDescriptionNameType] = useState("");
  const [conditionMethod, setConditionMethod] = useState("");
  const [tags, setTags] = useState([]);
  const [discriptionMethod, setDiscriptionMethod] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const navigate = useNavigate();
  const subdomain = localStorage.getItem("vendorsubdomain");
  const headers = useAuthHeaders();
  const textValues = tags.map((item) => item.text);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GETSingleDESTYPe(subdomain, _id);
        if (response.success) {
          const data = response.descriptiontype;
          setNewEditDescriptionNameType(data);
          setConditionMethod(data?.type);
          setTags(data?.descriptionnametypes?.map((tag) => ({ id: tag, text: tag })));
        }
      } catch (error) {
        console.error("Error fetching single type:", error);
      }
    };

    fetchData();

    axios
      .get(`${API_BASE_URL}/type/admin/gettypes`, { headers })
      .then((response) => {
        setDiscriptionMethod(response.data?.types || []);
      })
      .catch((error) => {
        console.error("Error fetching types:", error);
      });
  }, [_id, headers]);

  const handleSave = async (e) => {
    e.preventDefault();
    const payload = { descriptionnametypes: textValues };

    try {
      const response = await UpdateDESVendorTYPe(subdomain, payload, _id);
      if (response?.success) {
        setSnackbar({ open: true, message: response.message, severity: "success" });
        setTimeout(() => {
          navigate(`/${subdomain}/master/description-type`);
        }, 1500);
      } else {
        setSnackbar({
          open: true,
          message: response?.message || "Update failed",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Update error:", err);
      setSnackbar({
        open: true,
        message: "Unable to update the record.",
        severity: "error",
      });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Edit Description Name Type
      </Typography>

      <Paper
        component="form"
        onSubmit={handleSave}
        sx={{ p: 3, boxShadow: 3 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">Category:</Typography>
            <Typography variant="body1" color="text.secondary">
              {newEditDescriptionNameType?.category?.name}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">Sub Category:</Typography>
            <Typography variant="body1" color="text.secondary">
              {newEditDescriptionNameType?.subcategory?.name}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">Description Name Type:</Typography>
            <Typography variant="body1" color="text.secondary">
              {newEditDescriptionNameType?.descriptionname?.descriptionName}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2">Type:</Typography>
            <Typography variant="body1" color="text.secondary">
              {newEditDescriptionNameType?.type}
            </Typography>
          </Grid>

          {(conditionMethod === "Drop Down" || conditionMethod === "Check Box") && (
            <Grid item xs={12}>
              <DescriptionTypesField setTags={setTags} tags={tags} />
            </Grid>
          )}
        </Grid>

        <Box mt={3} display="flex" gap={2}>
          <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: "#0443C0" }}
          >
            Save
          </Button>
          <CancelButton path={`/${subdomain}/master/description-type`} />
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default EditDescriptionNameVendorTypesDetialEdit;
